import { render, staticRenderFns } from "./BookingDetailsDialog.vue?vue&type=template&id=38d957f2&scoped=true"
import script from "./BookingDetailsDialog.vue?vue&type=script&lang=ts"
export * from "./BookingDetailsDialog.vue?vue&type=script&lang=ts"
import style0 from "./BookingDetailsDialog.vue?vue&type=style&index=0&id=38d957f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d957f2",
  null
  
)

export default component.exports